import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { changeAppState } from "../../../../../../../../common/appState";
import { useVirtualScrollDummyCard } from "../../../../../../../../common/hooks/useVirtualScrollDummyCard";
import { spaceBetween } from "../../../../../../../../common/util/Array/spaceBetween";
import { EllipsisLabel } from "../../../../../../../shared/EllipsisLabel/EllipsisLabel";
import { UserAvatar } from "../../../../../../../shared/User/UserAvatar/UserAvatar";
import { UserForMessageList } from "../../../../../../../shared/User/types";

export const myPageMessageCardScrollableContainerHeight = 308;

export function MessagedUserRecord({
    messagedUser,
    colorNumber,
    scrollTop,
    index,
}: {
    messagedUser: UserForMessageList;
    colorNumber: number;
    scrollTop: number;
    index: number;
}) {
    const c = useStyles();

    const openMessagePanel = () => {
        changeAppState("messagePanelState", {
            targetUserId: messagedUser.userId,
            targetUserIconColorNumber: colorNumber,
        });
    };

    const { cardRef, isDummyCard } = useVirtualScrollDummyCard(
        scrollTop,
        myPageMessageCardScrollableContainerHeight,
        cardHeight,
        index
    );

    if (isDummyCard) {
        return <div className={c.dummyCard} ref={cardRef} key="outsideCard" />;
    }

    return (
        <Card
            className={c.card}
            onClick={openMessagePanel}
            ref={cardRef}
            key="outsideCard"
        >
            <div className={c.avatarContainer}>
                <UserAvatar
                    user={messagedUser}
                    colorNumber={colorNumber}
                    size={40}
                />
            </div>
            <div className={c.nameAndCount}>
                <div className={c.name}>
                    <EllipsisLabel title={messagedUser.name} placement="top" />
                </div>
                <div className={c.unreadCount}>
                    {messagedUser.unreadMessageCount > 0 && (
                        <Card className={spaceBetween("nowrap", c.new)}>
                            New
                        </Card>
                    )}
                    <span className="bold">
                        {messagedUser.unreadMessageCount || ""}
                    </span>
                </div>
            </div>
        </Card>
    );
}
const cardHeight = 50;
const useStyles = makeStyles(theme => ({
    card: {
        margin: 5,
        display: "flex",
        padding: 5,
        height: cardHeight,
        justifyContent: "center",
        width: "calc(100% - 10px)",
        position: "relative",
        overflow: "visible",
        cursor: "pointer",
    },
    dummyCard: {
        margin: 5,
        height: cardHeight,
    },
    avatarContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginLeft: 5,
        marginRight: 20,
        minWidth: 35,
        cursor: "pointer",
    },
    nameAndCount: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        width: "calc(100% - 65px)",
        height: "100%",
    },
    name: {
        width: "100%",
        paddingRight: 20,
        maxWidth: "100%",
        overflow: "hidden",
        cursor: "pointer",
    },
    new: {
        position: "absolute",
        top: -10,
        right: -20,
        backgroundColor: theme.palette.secondary.main,
        color: "white",
        padding: "0 5px",
        transform: "rotate(15deg)",
        zIndex: 1,
        fontSize: "small",
    },
    unreadCount: {
        width: 70,
        marginRight: 10,
        display: "flex",
        justifyContent: "flex-end",
        height: "100%",
        alignItems: "center",
        color: theme.palette.secondary.main,
        position: "relative",
    },
}));
